import React from 'react';
import { formatCurrency } from '../../../utils/baseUtils';
import { cn } from '../../../components/ui/_cn';

// The mock's hero numeral: "$" "26" ".45" "USD" on one baseline, each at
// its own size (spec 2026-09-21 §4.1). formatCurrency owns the digits and
// the grouping; this only cuts its output at the last "." and moves the
// leading "$" into the sign slot. A negative available balance — Stripe
// allows one — gets a real minus and a red integer, never a "-" swallowed
// into the number.
export const splitAmount = (amount) => {
  const value = typeof amount === 'number' && Number.isFinite(amount) ? amount : 0;
  const formatted = formatCurrency(Math.abs(value));
  const dot = formatted.lastIndexOf('.');
  return {
    negative: value < 0,
    symbol: formatted.charAt(0),
    integer: formatted.slice(1, dot),
    cents: formatted.slice(dot),
  };
};

// formatCurrency is USD-only and the API pins the balance to usd; the
// suffix reads the field anyway so the day that changes, this does not lie.
// `showCurrency={false}` drops it: Overview's balance card (v3, 2026-10-11)
// draws no "USD" beside the numeral.
// A negative figure is one hue (owner, 2026-09-23: a red minus and integer
// beside a grey "$" and ".26" read as two amounts): the integer in full red,
// the minus joined to the sign and the cents in the same red, lighter — the
// same hierarchy the grey tones give a positive figure.
const HeroAmount = ({ amount, currency = 'usd', showCurrency = true }) => {
  const { negative, symbol, integer, cents } = splitAmount(amount);
  return (
    <div className="flex items-baseline gap-1 tabular-nums">
      <span className={cn('text-[24px] font-semibold', negative ? 'text-fin-red/70' : 'text-fin-faintest')}>
        {negative ? `−${symbol}` : symbol}
      </span>
      <span
        className={cn(
          'text-[52px] font-bold leading-none tracking-[-0.04em]',
          negative ? 'text-fin-red' : 'text-fin-ink',
        )}
      >
        {integer}
      </span>
      <span
        className={cn('text-[24px] font-semibold tracking-[-0.02em]', negative ? 'text-fin-red/70' : 'text-fin-muted')}
      >
        {cents}
      </span>
      {showCurrency ? (
        <span className="ml-1.5 text-[13px] font-semibold text-fin-faintest">
          {String(currency || 'usd').toUpperCase()}
        </span>
      ) : null}
    </div>
  );
};

export default HeroAmount;
